import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import { Theme } from '../../config/theme';

import ErrorContainer from '../ErrorContainer';

const ARROW_ASSET = require('./arrow.svg');

export default class SelectField extends Component {
  constructor(props) {
    super(props);
    this.assignClasses = this.assignClasses.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      error: this.props.error,
    };
  }

  handleChange(event) {
    this.props.handleChange();

    if (this.props.required && event.target.value.length === 0) {
      this.setState({
        error: 'This field is required',
      });
    }

    if (this.props.handler && typeof this.props.handler === 'function') {
      this.props.handler(this.props.name, event.target.value);
    }
  }

  assignClasses() {
    this.fieldClasses = [
      styles.field,
      this.props.fullWidth ? styles.field_fw : null,
      this.props.styles,
    ];

    this.labelClasses = [
      styles.label,
      this.props.error ? styles.label_error : null,
    ];

    this.inputClasses = [
      styles.input,
      this.props.error ? styles.input_error : null,
    ];
  }

  render() {
    this.assignClasses();

    return (
      <div className={css(this.fieldClasses)}>
        <div className={css(styles.select_container)}>
          <select
            id={this.props.id}
            name={this.props.name}
            className={css(this.inputClasses)}
            required
            disabled={this.props.disabled}
            onChange={this.handleChange}
            value={this.props.value}
          >
            <option value="" disabled selected={this.props.value ? false : 'selected'}>
              {this.props.placeholder ? this.props.placeholder : `Select ${this.props.label}`}
            </option>
            {this.props.options.map(option =>
              (<option
                key={option.value}
                className={css(styles.includes_item)}
                value={option.value}
                >
                {option.label}
              </option>),
            )}
          </select>
          <Isvg
            cacheGetRequests
            src={ARROW_ASSET}
            className={css(styles.select_arrow)}
          />
        </div>
        {this.props.error ?
          <ErrorContainer message={this.props.error} />
        : null}
      </div>
    );
  }
}

SelectField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  hideLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func,
  handler: PropTypes.func,
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
};

SelectField.defaultProps = {
  placeholder: null,
  error: null,
  value: null,
  textArea: false,
  fullWidth: false,
  disabled: false,
  hideLabel: false,
  required: false,
  styles: null,
  handleChange: () => {},
  handler: () => {},
};

const styles = StyleSheet.create({
  select_container: {
    position: 'relative',
  },
  field: {
    position: 'relative',
    width: '50%',
    marginBottom: 15,
    padding: '0 5px',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  field_fw: {
    width: '100%',
  },
  label: {
    display: 'block',
    marginBottom: 9,
    fontFamily: Theme.fontFamily,
    fontSize: 14,
    color: '#828282',
  },
  label_error: {
    color: '#E85E5E',
  },
  input: {
    width: '100%',
    height: 50,
    padding: '0 16px',
    fontFamily: Theme.fontFamily,
    fontSize: 15,
    color: '#000e1f',
    borderRadius: 3,
    backgroundColor: '#fff',
    border: '1px solid #e4e4e4',
    outline: 'none',
    transition: 'all 300ms',
    appearance: 'none',
    cursor: 'pointer',

    '::placeholder': {
      fontSize: 14,
      color: '#bbb',
    },

    ':invalid': {
      fontSize: 14,
      color: '#bbb',
    },

    ':focus': {
      borderColor: Theme.turquoise,
    },

    ':disabled': {
      backgroundColor: '#f5f5f5',
      color: '#828282',
      cursor: 'not-allowed',
    },
  },
  input_error: {
    color: '#E85E5E',
    borderColor: '#E85E5E',
    borderWidth: 2,
    borderRadius: '3px 3px 0 0',

    ':invalid': {
      color: '#E85E5E',
    },

    ':focus': {
      borderColor: '#E85E5E',
    },
  },
  select_arrow: {
    position: 'absolute',
    bottom: 0,
    right: 20,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    height: 50,
    width: 9,
    pointerEvents: 'none',
    transition: 'all 300ms',
  },
});



// WEBPACK FOOTER //
// ./src/components/SelectField/index.js